import { ColoursObj, Icon } from "@eventr/common-storybook";
import { openBrowser } from "utils";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "./cardText";
import { RowInfo } from "./rowInfo";

interface IRowInfoWebProps {
  website: string;
  type?: "card" | "page";
}
export const RowInfoWeb = ({ website, type }: IRowInfoWebProps) => {
  const { past } = useObjectContext();
  const onClick = (link: any) => {
    const newUrl = link.startsWith("http") ? link : "https://" + link;
    openBrowser(newUrl);
  };
  if (type === "page") {
    return (
      <RowInfo
        start={<Icon name="Internet" iconColour={ColoursObj.core.secondary} />}
        middle={
          <CardText
            variant="bodyBoldUnderlined"
            onClick={(e) => {
              onClick(website);
              e.stopPropagation();
            }}
          >
            {"Website"}
          </CardText>
        }
      />
    );
  }
  return (
    <RowInfo
      start={
        <Icon name="Link" bubble bubbleColour={past ? ColoursObj.shades.shade2 : ColoursObj.coreBrights.tertiary} />
      }
      middle={
        <CardText
          variant="bodyBoldUnderlined"
          onClick={(e) => {
            onClick(website);
            e.stopPropagation();
          }}
        >
          {"Website"}
        </CardText>
      }
    />
  );
};
